import React, { useState, useRef, useEffect } from 'react';
import axios from 'axios';
import Header from "../../components/Header";
import Footer from "../../components/Footer";

export default function CryptoTutor() {
    const [userInput, setUserInput] = useState('');
    const [messages, setMessages] = useState([]);
    const [isTyping, setIsTyping] = useState(false);
    const chatEndRef = useRef(null);
    const messagesEndRef = useRef(null);

    useEffect(() => {
        // Scroll to the bottom only if the user is already at the bottom of the chat
        const isAtBottom = messagesEndRef.current && 
            messagesEndRef.current.getBoundingClientRect().top <= window.innerHeight;
        if (isAtBottom) {
            chatEndRef.current?.scrollIntoView({ behavior: "smooth" });
        }
    }, [messages, isTyping]);

    const handleSend = async () => {
        if (!userInput.trim()) return;

        const newMessages = [...messages, { sender: 'You', text: userInput }];
        setMessages(newMessages);
        setUserInput('');
        setIsTyping(true);

        try {
            const res = await axios.post('https://crypto-co.nugenesisou.com/teach', { user_input: userInput });
            setMessages([...newMessages, { sender: 'Navis', text: res.data.response }]);
        } catch (err) {
            setMessages([...newMessages, { sender: 'Navis', text: 'Error: Could not reach server.' }]);
        } finally {
            setIsTyping(false);
        }
    };

    // Prevent the default action of Enter key press to avoid scrolling
    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault(); // Prevent Enter from causing page scroll
            handleSend(); // Handle sending message
        }
    };

    return (
        <>
            <Header />
            <main style={{ backgroundColor: '#0c0f1a', color: '#ffffff', minHeight: '100vh' }}>
                <section className="pad breadcrumbs top-cover">
                    <div id="breadcrumb" className="content">
                        <a href="Home">Home</a><i></i>
                        <span>Crypto Trading Tutor</span>
                    </div>
                </section>

                <section className="security-hero not-min-height">
                    <div className="content">
                        <div className="pad texts full-width">
                            <h1 style={{ color: '#0cc2ff' }}><b style={{ fontSize: 60 }}>Crypto Trading Tutor</b></h1>
                            <p style={{ color: '#ccc', fontSize: 20, textAlign: 'center' }}>
                                Navis simplifies the complex world of cryptocurrency for new traders. Learn essential terms, trading strategies, market trends, and risk management step by step. Whether you're curious about Bitcoin or ready to place your first trade, Navis is here to coach you with clear, jargon-free advice.
                            </p>
                        </div>
                    </div>
                </section>

                <section className="pad security-hero">
                    <div className="content">
                        <div className="seer-chat-container" style={{
                            backgroundColor: '#242836',
                            padding: 20,
                            borderRadius: 10,
                            maxWidth: 800,
                            margin: '0 auto'
                        }}>
                            <div style={{
                                height: 400,
                                overflowY: 'auto',
                                padding: 15,
                                backgroundColor: '#1e1e24',
                                borderRadius: 8,
                                marginBottom: 15,
                                border: '1px solid #333',
                                display: 'flex',
                                flexDirection: 'column'
                            }}>
                                {messages.map((msg, i) => (
                                    <div
                                        key={i}
                                        style={{
                                            margin: '10px 0',
                                            alignSelf: msg.sender === 'You' ? 'flex-end' : 'flex-start',
                                            textAlign: msg.sender === 'You' ? 'right' : 'left',
                                            maxWidth: '75%',
                                            backgroundColor: msg.sender === 'You' ? '#0cc2ff22' : '#444',
                                            padding: 10,
                                            borderRadius: 8
                                        }}
                                    >
                                        <strong style={{ color: msg.sender === 'You' ? '#0cc2ff' : '#ffcc00' }}>
                                            {msg.sender}:
                                        </strong>
                                        <div style={{ color: '#fff' }}>{msg.text}</div>
                                    </div>
                                ))}
                                {isTyping && (
                                    <div style={{
                                        alignSelf: 'flex-start',
                                        backgroundColor: '#444',
                                        padding: 10,
                                        borderRadius: 8,
                                        color: '#ffcc00'
                                    }}>
                                        Navis is typing...
                                    </div>
                                )}
                                <div ref={messagesEndRef} />
                            </div>

                            <div style={{ display: 'flex' }}>
                                <input
                                    type="text"
                                    value={userInput}
                                    onChange={e => setUserInput(e.target.value)}
                                    onKeyDown={handleKeyDown} // Ensure the key press event is handled properly
                                    placeholder="Ask the bot anything..."
                                    style={{
                                        flex: 1,
                                        padding: 12,
                                        borderRadius: 5,
                                        border: '1px solid #333',
                                        backgroundColor: '#1e1e24',
                                        color: '#fff'
                                    }}
                                />
                                <button onClick={handleSend} style={{
                                    padding: '12px 20px',
                                    marginLeft: 10,
                                    backgroundColor: '#0cc2ff',
                                    border: 'none',
                                    borderRadius: 5,
                                    color: '#000',
                                    fontWeight: 'bold',
                                    cursor: 'pointer'
                                }}>
                                    Send
                                </button>
                            </div>
                        </div>
                    </div>
                </section>
            </main>
            <Footer />
        </>
    );
}
